import { ReactNode, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'

import styles from './Layout.module.css'
import { t } from 'i18next'

type BackgroundColor = 'accentColor' | ''

interface LayoutProps {
  children: ReactNode
  hasBackButton?: boolean
  containerStyle?: string
  backgroundColor?: BackgroundColor
  backButtonAction?: () => void
  contentStyles?: React.CSSProperties
}

const Layout = forwardRef<HTMLDivElement, LayoutProps>(
  (
    {
      children,
      hasBackButton,
      containerStyle = 'layoutContainer',
      backgroundColor = '',
      backButtonAction,
      contentStyles = {},
    },
    ref,
  ) => {
    const navigate = useNavigate()

    const handleBackButtonClick = () => {
      if (backButtonAction) {
        backButtonAction()
      } else {
        navigate(-1)
      }
    }

    return (
      <div
        ref={ref}
        className={`${styles[containerStyle]} ${styles[backgroundColor]} `}
      >
        {hasBackButton && (
          <div onClick={handleBackButtonClick} className={styles.backButton}>
            <ChevronLeftRoundedIcon
              sx={{ color: 'var(--color-accent-darkest)' }}
              fontSize="large"
            />
            {t('layout.back')}
          </div>
        )}
        <main
          className={styles.mainStyle}
          style={{
            ...contentStyles,
            height: hasBackButton ? 'calc(100dvh - 67px)' : '100dvh',
          }}
        >
          {children}
        </main>
      </div>
    )
  },
)

export default Layout
